module.exports = __webpack_public_path__ + "img/Sass_Logo.e0f651ac.svg";